import RouterProvider from './RouterProvider';

export {
    Routes,
    Route,
    Link,
    Outlet,
    useLocation,
    useParams,
    type Location,
    useNavigate as useNativeNavigate,
    Navigate,
} from 'react-router-dom';

export { default as useNavigate, type UseNavigateHook } from './hooks/useNavigate/useNavigate';
export { default as useNavigateBack } from './hooks/useNavigateBack/useNavigateBack';

export { default as hydrateUrlParametersFactory } from './utils/hydrateUrlParameters/hydrateUrlParametersFactory';

export type { RouteWithChildren, TypeConstrainedNavigateComponent } from './types';

export default RouterProvider;
